import styles from "./fetching.module.scss";

const CustomFetching = ({ message, size = "md", className = "", style, primaryColor, center = false }) => {
	const styleVars = {
		...(primaryColor ? { "--cf-primary": primaryColor } : null),
		...style,
	};

	const wrapperCls = [styles.wrapper, styles[size], center ? styles.center : "", className].filter(Boolean).join(" ");

	return (
		<div className={wrapperCls} role="status" aria-live="polite" aria-busy="true" style={styleVars}>
			<div className={styles.spinner} aria-hidden="true" />
			{message ? <div className={styles.text}>{message}</div> : null}
		</div>
	);
};

export default CustomFetching;
